// routes/ProtectedRoutes.js
import { Navigate, useLocation } from "react-router-dom";
import { useUserData } from "../hooks/useUserData";

export const ProtectedRoute = ({
  allowedRole,
  requiredModule,
  requiredPermission = "view",
  children,
}) => {
  const { userRole, maintainerData } = useUserData();
  const location = useLocation();

  if (!userRole) {
    return <Navigate to="/admin/login" replace />;
  }

  // Admin users have full access to everything
  if (userRole === "admin") {
    return children;
  }

  if (userRole === "maintainer") {
    if (!requiredModule) {
      return children;
    }

    // Find the specific module permission
    const modulePermission = maintainerData?.permissions.find(
      (permission) => permission.module === requiredModule
    );

    // Check if maintainer has access to this module
    if (!modulePermission) {
      return <Navigate to="/admin/dashboard" replace />;
    }

    // Check view permission
    if (!modulePermission.view) {
      return <Navigate to="/admin/dashboard" replace />;
    }

    // Check edit permission for create/edit routes
    if (requiredPermission === "edit" && !modulePermission.edit) {
      return <Navigate to="/admin/dashboard" replace />;
    }

    // Special handling for Communication module
    if (requiredModule === "Communication") {
      const currentPath = location.pathname;

      // Check SMS permissions
      if (currentPath.includes("/sms/") && !modulePermission.sms) {
        return <Navigate to="/admin/dashboard" replace />;
      }

      // Check WhatsApp permissions
      if (currentPath.includes("/whatsapp/") && !modulePermission.whatsapp) {
        return <Navigate to="/admin/dashboard" replace />;
      }

      // Check Email permissions
      if (currentPath.includes("/email/") && !modulePermission.email) {
        return <Navigate to="/admin/dashboard" replace />;
      }
    }

    return children;
  }

  if (userRole === "member" && allowedRole === "member") {
    return children;
  }

  // Default: redirect to appropriate login
  if (allowedRole === "member") {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/admin/login" replace />;
};
